import { Component, OnInit } from '@angular/core';
import { GlobalErrorService } from '@services/global-error.service';
import { VendorService as SharedVendorService } from '@services/vendor.service';
import { getNoDataMessage, PageTitle } from '@constants/global.enum';
@Component({
  selector: 'app-upcoming-interviews',
  templateUrl: './upcoming-interviews.component.html',
  styleUrls: ['./upcoming-interviews.component.scss'],
})
export class upcomingInterviews implements OnInit {
  interviews: any[] = [];
  filteredInterviews: any[] = [];
  filterValue: string = '';
  imageSrc: string = 'assets/img/no-data-found.png';
  readonly PAGINATION_MIN_RECORDS = 5;
  paginationParams = {
    enabled: this.filteredInterviews?.length > this.PAGINATION_MIN_RECORDS,
    pageSize: 5,
    pageSizeOptions: [5, 10, 20],
  };
  pageTitle = PageTitle.UpcomingInterviews;
  noDataMessage = getNoDataMessage('upcomingInterviews');
  altText = getNoDataMessage('alt');

  columnDefs = [
    { field: 'name', headerName: 'Name', sortable: true },
    { field: 'position', headerName: 'Position', sortable: true },
    { field: 'interviewer', headerName: 'Interviewer', sortable: true },
    { field: 'totalExperience', headerName: 'Total Exp', sortable: true },
    { field: 'date', headerName: 'Date', sortable: true },
  ];

  constructor(
    private sharedVendorService: SharedVendorService,
    private globalErrorService: GlobalErrorService,
  ) {}

  ngOnInit(): void {
    this.sharedVendorService.currentVendor$.subscribe({
      next: (vendor) => {
        if (vendor) {
          this.loadInterviews();
        }
      },
    });
    this.updatePagination();
  }

  loadInterviews(): void {
    this.sharedVendorService.fetchUpcomingInterviews().subscribe({
      next: (response) => {
        this.interviews = response.data.map((interview: any) => ({
          name: interview.candidateName || '',
          position: interview.position || 'Not Specified',
          interviewer: interview.interviewer || '',
          totalExperience: interview.yearsOfExperience || 0,
          date: interview.interviewDate
            ? new Date(interview.interviewDate).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })
            : '',
        }));
        this.filteredInterviews = [...this.interviews];
        this.updatePagination();
      },
      error: (error) => this.globalErrorService.logComponentError(error)
    });
  }

  searchInterviews(event: KeyboardEvent): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase().trim();
    
    this.filteredInterviews = !searchTerm 
      ? [...this.interviews]
      : this.interviews.filter(interview =>
          Object.values(interview).some(value => 
            value?.toString().toLowerCase().includes(searchTerm)
          )
        );
    
    this.updatePagination();
  }

  clearInput(): void {
    this.filterValue = '';
    this.filteredInterviews = [...this.interviews];
    this.updatePagination();
  }

  updatePagination(): void {
    this.paginationParams.enabled =
      this.filteredInterviews?.length > this.PAGINATION_MIN_RECORDS;
  }
}
